export function useMarkerIO() {
  return useNuxtApp().$marker
}
